import { useStore } from "ra-core";

/** The view a list displays, remembered per browser under `storeKey`. */
export const useListView = <View extends string>(
  storeKey: string,
  defaultView: View,
) => useStore<View>(storeKey, defaultView);
